import React, {Component} from 'react';

class ScrollIndicator extends Component {

    constructor(props) {
        super(props);

        this.SCROLL_HEIGHT_TOLERANCE = 300;
        this.HEADER_OFFSET = 60;

        this.state = {
            current: props.startPos
        };
    }

    render(){
        return (
            <div className="scroll-indiaction-container">
                {Object.entries(this.props.refs).map(([refName,ref]) => {
                    return <div className={'little-circle' + (this.state.current === refName ? ' current' : '')}
                            key={refName} onClick={()=> this.scrollToRef(ref)}/>
                })}
            </div>
        );
    }

    componentDidMount = () => {
        window.onscroll = () => {
            this.setCurrent()
        }
    }

    setCurrent = () => {
        Object.entries(this.props.refs).forEach(([refName,ref]) => {
            const top = ref.current.getBoundingClientRect().top;
            if ((top) >= 0 && (top) <= this.SCROLL_HEIGHT_TOLERANCE){
                this.setState({current: refName});
            }
        })
    }

    scrollToRef = (ref) => {
        console.log(ref.current.offsetTop);
        window.scrollTo({
        top: ref.current.offsetTop-this.HEADER_OFFSET,
        left: 0,
        behavior: 'smooth'
    })}
}

export default ScrollIndicator;